import { Preference } from './Preference';
import { Company, defaultCompany } from './Company';

export interface Event {
    id: number;
    title: string;
    description?: string;
    start_date?: string;
    end_date?: string;
    start_hour?: string;
    end_hour?: string;
    preferences?: Preference[];
    event_type: string;
    is_active: boolean;
    company?: Company;
    company_id: number;
    is_private: boolean;
    is_published: boolean;
    commune_id?: number;

    region_id?: number;

    country_id?: number;

    address?: string;

    image?: string;

    uuid?: string;
}

export const defaultEvent: Event = {
    company_id: 0,
    title: '',
    id: 0,
    event_type: 'Presencial',
    is_active: true,
    is_private: false,
    is_published: false,
};

export interface EventFilters {
    title?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
